module.exports = __webpack_public_path__ + "img/spot1.ecd653f4.jpg";